// extracted by mini-css-extract-plugin
export default {"Container":"SearchBar_Container__gALZw","SearchBar":"SearchBar_SearchBar__HGTg2","Searchbar__icon":"SearchBar_Searchbar__icon__tb86r","Pointer":"SearchBar_Pointer__k8z+u"};